<template>
    <div class="wrapper">
        <!-- 顶部装饰背景区 -->
        <div class="header-bg">
            <div class="header-title">自助停车缴费</div>
        </div>

        <!-- 核心输入卡片 -->
        <div class="card-container input-card">
            <div class="div_name">
                <i class="icon-car"></i> 请输入车牌号进行查询
            </div>
            
            <plate-input ref="plateInput1"></plate-input>
            
            <div 
                class="div_button" 
                :class="{ 'is-loading': isLoading }"
                @click="handleConfirm"
            >
                {{ isLoading ? '查询中...' : '确认查询' }}
            </div>
        </div>

        <!-- 底部温馨提示区 (提取自你原有CSS但未在HTML中使用的部分) -->
        <div class="card-container div_explain">
            <div class="explain_name">温馨提示</div>
            <div class="div_text">
                <p>1. 请确保输入的车牌号真实有效；</p>
                <p>2. 支付成功后，请在规定时间内（通常为15分钟）离场，超时将重新计费；</p>
                <p>3. 若已在场内支付，请直接前往出口处扫码或识别离场。</p>
            </div>
        </div>
    </div>
</template>

<script>
import { getRecordByPlateNo, getParkinglotInfo, order } from "../api/coupon/platePay";
import { validatePlate } from '@/utils/plateValidator';
import plateInput from '../components/weChat/components/plateInput.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'PlatePay',
    components: {
        plateInput
    },
    data() {
        return {
            isLoading: false, // 新增：控制按钮 loading 状态防抖
            parkinglotId: undefined,
            totalPrice: undefined,
            plateNumber: undefined,
            parkRec: undefined,
            parkRecInfo: {},
            comeFrom: ''
        };
    },
        computed: {
        ...mapGetters(['userOpenid', 'keyTopOrderNo'])
    },
    mounted() {
        console.log("this.$route.query", this.$route.query);

        const query = this.$route.query || {};
        this.plateNumber = query.plateNumber ? decodeURIComponent(query.plateNumber) : '';
        this.parkinglotId = query.parkinglotId ? decodeURIComponent(query.parkinglotId) : undefined;

        // 将路由传来的车牌号回显到子组件
        this.$nextTick(() => {
            if (this.plateNumber && this.$refs.plateInput1 && this.$refs.plateInput1.setPlateNumber) {
                this.$refs.plateInput1.setPlateNumber(this.plateNumber);
            }
        });
    },
    methods: {
        ...mapMutations({
            setOrderInfo: "SET_ORDER_INFO",
            setParkrec: "SET_PARKREC",
            setParkingId: "SET_PARKINGLOTID",
            setParkingInfo: "SET_PARKING_INFO",
            setAreaId: 'SET_AREA_ID',
            setKeyTopOrderNo: "SET_KEYTOPORDERNO"
        }),
        
        handleConfirm() {
            if (this.isLoading) return; // 防止重复点击
            
            const currentPlate = this.$refs.plateInput1.getPlateNumber();
            
            // 恢复车牌正则校验，提升前置拦截体验
            if (!validatePlate(currentPlate).valid) {
                this.$weui.topTips('请输入正确的车牌号'); 
                return;
            }

            this.isLoading = true;
            let form = {
                plateno: currentPlate,
                parkinglotId: this.parkinglotId
            };
             console.log("this.parkinglotId", this.parkinglotId);
            if(!this.parkinglotId){
                console.log("2222222222");
                delete form.parkinglotId;
            }
             console.log("form", form);
            getRecordByPlateNo(form).then(res => {
                if (res.code == 200) {
                    this.parkFeeToast(res);
                } else {
                    this.$weui.alert(res.msg || '未查询到该车辆信息', { title: '提示' });
                }
            }).catch(err => {
                this.$weui.toast('网络请求失败', { type: 'cancel' });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        
        parkFeeToast(res) {
            if (res.code == 200 && res.data) {
                const data = res.data;
                this.parkinglotId = data.parkinglotId;
                this.totalPrice = data.unpaidMoney;
                this.parkRec = data.id;
                this.parkRecInfo = data;
                
                this.setAreaId(data.areaId);
                this.setKeyTopOrderNo(data.keyTopOrderNo);
                this.getParkinglotInfo(data.parkinglotId);
                
                const plateStr = this.$refs.plateInput1.getPlateNumber();

                if (data.actualMoney) {
                    this.$weui.alert('已场内支付过，请至出口扫码缴费', { title: '提醒' });
                } else if (this.totalPrice == 0) {
                    // 移除了不规范的 &nbsp; 使用，UI上更清爽
                    this.$weui.alert(`车牌为『${plateStr}』的车主您好，您需要缴费 ${data.unpaidMoney} 元，无需支付。`, { title: "提醒" });
                } else {
                    this.showConfirm(data.couponid, plateStr);
                }
            } else if (res.code == 500) {
                this.$weui.alert('当前无车辆出场记录', { title: '请前往岗亭付费' });
            }
        },
        
        getParkinglotInfo(id) {
            getParkinglotInfo(id).then(res => {
                if (res.code == 200) {
                    this.setParkingInfo(res.data);
                }
            }).catch(err => console.error(err));
        },
        
        showConfirm(couponid, plateStr) {
            this.$weui.dialog({
                title: '缴费提醒',
                content: `车牌为『${plateStr}』的车主您好，您当前停车费用为 <strong style="color:#ff5722">${this.totalPrice}</strong> 元。`,
                className: 'custom-classname',
                buttons: [
                    {
                        label: '取消',
                        type: 'default',
                        onClick: () => {}
                    }, 
                    {
                        label: '去缴费',
                        type: 'primary',
                        onClick: () => {
                            let form = {
                                totalPrice: parseFloat(this.totalPrice).toFixed(2),
                                parkRec: this.parkRec,
                                parkinglotId: this.parkinglotId,
                                goodsType: 3,
                                closed: 0,
                                paymentPlatform:this.checkBrowser.id,
                                paymentPlatformsn: this.keyTopOrderNo
                            };
                            
                            // 开启全局 loading 防止路由跳转前的白屏等待
                            const loading = this.$weui.loading('正在创建订单...'); 
                            
                            order(form).then(res => {
                                loading.hide();
                                if (res.code == 200) {
                                    this.setParkrec(this.parkRecInfo);
                                    this.setParkingId(this.parkinglotId);
                                    this.setOrderInfo(res.data);
                                    this.$router.push({ name: "InsideOrder", params: { isEntry: true } });
                                } else {
                                    setTimeout(() => {
                                        this.$weui.alert(res.data.msg || '订单创建失败', { title: '提示' });
                                    }, 300);
                                }
                            }).catch(err => {
                                loading.hide();
                                this.$weui.toast('系统异常', { type: 'cancel' });
                            });
                        }
                    }
                ]
            });
        },
    }
};
</script>

<style lang="stylus" scoped>
    @import '~common/stylus/variable';
    @import '~common/stylus/mixin';

    .wrapper {
        position: relative;
        width: 100%;
        min-height: 100vh;
        background: #f4f6f8; /* 让背景色稍微柔和一些 */
        display: flex;
        flex-direction: column;
        align-items: center;

        /* 顶部装饰条，打破死板的布局 */
        .header-bg {
            width: 100%;
            height: 150px;
            background: linear-gradient(135deg, #06ae56 0%, #059b4c 100%);
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
            display: flex;
            justify-content: center;
            padding-top: 30px;
            
            .header-title {
                color: #ffffff;
                font-size: 20px;
                font-weight: bold;
                letter-spacing: 2px;
            }
        }

        /* 统一卡片样式 */
        .card-container {
            width: 90%;
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* 添加柔和的阴影 */
            box-sizing: border-box;
   
        }

        /* 输入区卡片 */
        .input-card {
            position: relative; /* 必须有 position，z-index 才会生效 */
    z-index: 999;       /* 设置极高层级，确保内部弹出的键盘能盖住全场 */
    margin-top: -60px;
    padding: 24px 20px;

            .div_name {
                font-size: 16px;
                font-weight: bold;
                color: #333;
                margin-bottom: 25px;
                display: flex;
                align-items: center;
                
                .icon-car {
                    margin-right: 8px;
                    font-style: normal;
                }
            }

            .div_button {
                color: #ffffff;
                width: 100%;
                height: 48px;
                background: #06ae56;
                /* 修复原代码中绿底蓝阴影的视觉违和，改为绿色阴影 */
                box-shadow: 0px 6px 12px 0px rgba(6, 174, 86, 0.3); 
                border-radius: 8px; /* 增大一点圆角 */
                font-size: 17px;
                font-weight: 500;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                letter-spacing: 2px;
                margin-top: 24px;
                transition: all 0.2s ease-in-out;

                &:active {
                    transform: scale(0.98); /* 点击反馈特效 */
                    background: #059b4c;
                }

                &.is-loading {
                    background: #83d6ab; /* loading 状态下变浅色 */
                    box-shadow: none;
                    pointer-events: none; /* 禁止点击 */
                }
            }
        }

        /* 提示信息卡片 */
        .div_explain {
            position: relative;
            z-index: 1;         /* 层级放低 */
            margin-top: 20px;
            padding: 20px;

            .explain_name {
                font-size: 15px;
                margin-bottom: 15px;
                color: #333;
                font-weight: bold;
                border-left: 3px solid #06ae56;
                padding-left: 8px;
                line-height: 1;
            }

            .div_text p {
                margin: 0 0 8px 0;
                font-size: 13px;
                line-height: 1.5;
                color: #666;
            }
        }
    }
</style>